import { createSvgComponent } from "../../icon/createSvgComponent";
import BenefitNotification from "@core/icon/assets/benefit-notification.svg";
export default createSvgComponent(BenefitNotification);